import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { IAppState } from 'core/store/store'
import styles from './UpdateServices.module.scss'
import { Translate } from 'react-localize-redux'
import { UpdateServicesProps } from './UpdateServices.types'
import {
  Button,
  ButtonType,
  Card, CardContainer,
  CardContent,
  CardSizeTypes, Checkbox,
  Form,
  FormFieldSize,
  FormGroup,
  MultiSelect,
  SubmitButton
} from '@digicert/dcone-common-ui'
import { IAccessScope, IApplication, IUser } from 'reducers/Reducers.interfaces'
import { serviceIcon, translate } from 'shared/helpers/utils'
import { fetchTenantById } from 'secure-pages/tenants/Tenants.actions'
import { CERT_CENTRAL_SHORT_APP_CODE } from 'core/constants'
import { IOptions } from 'secure-pages/users/edit-user-with-role/EditUserWithRole.types'
import { editUser } from 'core/actions/Users.actions'
import { fetchServicesByUserId } from 'secure-pages/tenants/tenant/services/Services.actions'
import { fetchUserById } from 'core/actions/Users.actions'

export const UpdateServices = (
  { user, fetchTenantById, onCancel, editUser, setServices, fetchServicesByUserId, fetchUserById }: UpdateServicesProps) => {

  const [selectedServices, setSelectedServices] = useState<IApplication[] | undefined>()
  const [, setApplications] = useState<string[]>([])
  const [certCentralSpAccounts, setCertCentralSpAccounts] = useState<IOptions>()
  const [selectedSpCertCentralSpAccounts, setSelectedSpCertCentralSpAccounts] = useState<string[]>()
  const [certCentralId, setCertCentralId] = useState<string>('')
  const [accounts, setAccounts] = useState<any>([])
  const [enabledServices, setEnabledServices] = useState<IApplication[]>([])
  const profile = useSelector((state: IAppState) => state.profile.data)
  const [userState, setUserState] = useState<IUser | undefined>(user)

  useEffect(() => {
    if (!user) return
    fetchUserById(user.id).then((freshUser: IUser) => {
      setUserState(freshUser)
    })
  }, [onCancel])


  useEffect(() => {
    const applications = Object.keys(userState?.applications || {})
    const apps: string[] = []
    applications.forEach(
      (key) => {
        apps.push(userState?.applications[key].id)
      })
    setApplications(apps)
    if (profile && profile?.permissions.filter(perm => perm.name === 'VIEW_OL_ACCOUNT').length > 0) {
      fetchTenantById(userState?.primary_account_id).then((acc) => {
        setEnabledServices(acc?.applications)
        const selectedApps = acc?.applications.map(app => {
          if (apps.some(id => id === app.id)) {
            return app
          }
        }).filter(app => app !== undefined)
        setSelectedServices(selectedApps)
        acc.applications.map(application => {
          if (application.short_app_code === CERT_CENTRAL_SHORT_APP_CODE && application.service_provider_accounts) {
            setCertCentralId(application.id)
            const spOptions = application.service_provider_accounts.map(acc => {
              return {
                value: acc.id,
                label: acc.source_account_name + ' - ' + acc?.source_account_friendly_identifier
              }
            })
            setCertCentralSpAccounts(spOptions)
          }
        })
        applications.forEach(
          (key) => {
            const app = userState?.applications[key]
            if (app.short_app_code === CERT_CENTRAL_SHORT_APP_CODE) {
              setCertCentralId(app.id)
              if (app.service_provider_accounts) {
                const selectedCCAccounts: Array<string> = []
                app.service_provider_accounts.map(acc => {
                  selectedCCAccounts.push(acc.id)
                })
                setSelectedSpCertCentralSpAccounts(selectedCCAccounts)
              }
            }
          })
      })
    }
    setAccounts(userState?.accounts?.map(account => account.id) || []);
  }, [userState])

  const handleSpMultiSelect = (value): void => {
    setSelectedSpCertCentralSpAccounts(value)
  }

  const getApplications = () => {
    const applications: Array<any> = []
    const apps = [...enabledServices]
    if (apps) {
      Object.keys(apps).reduce(
        (val, key) => {
          const application = {
            name: apps[key].name,
            id: apps[key].id,
            is_retail: !!apps[key].is_retail
          }
          applications.push(application)
          return application
        },
        {}
      )
    }

    applications?.sort((a, b) => (a.label > b.label ? 1 : -1))
    return applications
  }

  const selectService = (e: MouseEvent, item: IApplication): void => {
    e.preventDefault()
    const tmpArray: IApplication[] = [...(selectedServices || [])]
    const serviceExists = selectedServices?.some(service => service.id === item.id)

    if (!serviceExists) {
      tmpArray.push(item)
      setSelectedServices(tmpArray)
    }

    else {
      const filterService = tmpArray.filter(service => service.id !== item.id)
      setSelectedServices(filterService)
      if (item.id === certCentralId) {
        setSelectedSpCertCentralSpAccounts([])
      }
    }
  }

  const handleCancel = (e) => {
    e.preventDefault()
    if (onCancel) {
      onCancel(e)
    }
  }

  const submit = (e) => {
    e.preventDefault()
    if (!user) return
    const formData: any = {
      "access_scope": user.access_scope === IAccessScope.system,
      "first_name": user.first_name,
      "last_name": user.last_name,
      "email": user.email,
      "user_name": user.user_name,
      "locale": user.locale,
      "phone": user.phone,
      "other_phone": user.other_phone,
      "saml_username": user.saml_username,
      "oidc_username": user.oidc_username,
      "group_ids": user.groups.map(group => {
        return group.id
      })
    }
    if (certCentralId && selectedSpCertCentralSpAccounts && selectedSpCertCentralSpAccounts.length > 0) {
      formData.service_provider_account_ids = { [certCentralId]: selectedSpCertCentralSpAccounts }
    }
    if (user.access_scope !== IAccessScope.system) {
      formData.accounts = accounts
      formData.application_ids = selectedServices?.map(selectedService => { return selectedService.id })
    }
    editUser(user.id, formData, false).then(() => {
      fetchServicesByUserId(user.id).then(res => {
        setServices && setServices(res.service_provider_accounts)
      })
      handleCancel(e)
    })
  }

  return (
    <div className={styles.editServices}>
      <h3><Translate id='accounts.availableServices' /></h3>
      <p><Translate id='accounts.userServiceSelectionDesc' /></p>
      <Form center={false} onSubmit={(e) => submit(e)}>
        <CardContainer className={styles.cardContainer}>
          {getApplications().map((item, index) => {
            const isRetail = item.is_retail
            return (
              <Card
                key={index}
                className={styles.card}
                size={CardSizeTypes.SMALL}
                onClick={isRetail ? undefined : (e: MouseEvent) => selectService(e, item)}
                content={
                  <CardContent>
                    <div className={styles.cardContent} key={index}>
                      <div>{serviceIcon(item.name)}</div>
                      <div className={styles.cardLabel}>{item.name}</div>
                      <div>
                        <Checkbox
                          checked={selectedServices?.some(app => app.id === item.id)}
                          disabled={isRetail}
                        />
                      </div>
                    </div>
                  </CardContent>}
                disabled={isRetail}
              />)
          })}
        </CardContainer>

        {certCentralSpAccounts && certCentralId !== '' &&
          selectedServices?.some(s => s.id === certCentralId) &&
          <>
            <h3><Translate id='manageUser.administrators.serviceAccounts' /></h3>
            <p><Translate id='manageUser.administrators.serviceAccountsDesc' /></p>
            <FormGroup>
              <MultiSelect
                help=""
                value={selectedSpCertCentralSpAccounts}
                placeholder={translate('common.form.select') as string}
                onChange={handleSpMultiSelect}
                allowClear={true}
                label={translate('manageUser.administrators.certCentralAccount') as string}
                size={FormFieldSize.L}
                // @ts-ignore
                options={certCentralSpAccounts}
              />
            </FormGroup>
          </>
        }

        <div className={styles.formActions}>
          <SubmitButton disabled={selectedServices?.length === 0}>
            <Translate id='common.form.buttons.updateServices' />
          </SubmitButton>
          <Button buttonType={ButtonType.SECONDARY} onClick={handleCancel}>
            <Translate id='common.form.buttons.cancelBtn' />
          </Button>
        </div>

      </Form>
    </div>
  )
}

export default connect(
  (state: IAppState) => {
    return {
    }
  },
  {
    fetchTenantById,
    fetchServicesByUserId,
    fetchUserById,
    editUser
  }
)(UpdateServices)
